import { RestService } from '../services/RestService';

export class ScheduledKinoLoungeMovieService extends RestService{
  constructor() {
    super("/api/v1/scheduled_kinolounge_movies");
  }
}
